import {FaRegFolder, FaX} from "react-icons/fa6";
import {FaTrash} from "react-icons/fa";
import Button from "../../../../components/button/button.jsx";

function SelectionButton({ onClick, title, children, actionFeedbackType, deferActionFeedback = false }) {
    return (
        <Button
            unstyled
            type="button"
            onClick={onClick}
            title={title}
            actionFeedbackType={actionFeedbackType}
            deferActionFeedback={deferActionFeedback}
            successClassName=""
            className="flex h-7 w-7 items-center justify-center rounded-full hover:bg-[#D1D6DB] cursor-pointer"
        >
            {children}
        </Button>
    )
}

export default function LibrarySelectionToolbar({ selectedItems = [], onClearSelection, onDeleteItems, hasPermission }) {
    const hasSelectedItems = selectedItems.length > 0;

    return (
        <>
            {hasSelectedItems && (
                <div className="flex h-6 items-center gap-3">
                    <div
                        className="flex items-center gap-2 rounded-full bg-[#E5E7EB] p-2 h-7 select-none"
                        onClick={(event) => event.stopPropagation()}
                    >
                        <SelectionButton
                            onClick={onClearSelection}
                            title="Limpar seleção"
                        >
                            <FaX />
                        </SelectionButton>
                        <p className="text-[16px]! font-semibold">
                            {selectedItems.length} {selectedItems.length === 1 ? "item selecionado" : "itens selecionados"}
                        </p>
                        {hasPermission && (
                            <SelectionButton
                                onClick={onDeleteItems}
                                title="Excluir"
                                actionFeedbackType="delete"
                                deferActionFeedback
                            >
                                <FaTrash />
                            </SelectionButton>
                        )}
                    </div>
                </div>
            )}
        </>
    )
}